
import $ from '../treant-vue/jquery/jquery-3.6.0.min.js'
import * as pdfjsLib from '../pdfjs-es5/es5/build/pdf';
pdfjsLib.GlobalWorkerOptions.workerSrc = import('../pdfjs-es5/es5/build/pdf.worker');

import './styles.css'
import './pdfannotate.css'
import {
    sopClientMethods,
} from '@/state/helpers'
import simplebar from "simplebar-vue";
import { PDFDocument } from 'pdf-lib'
// eslint-disable-next-line
import Swal from 'sweetalert2'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import pdfvuer from '@/components/widgets/pdf-view'

export default {
    // eslint-disable-next-line
    install(Vue, options) {
        Vue.mixin({
            created() { },
        });

        Vue.component('annotate-pdf', {
            components: {
                simplebar,
                //eslint-disable-next-line
                VuePdfEmbed,
                pdf: pdfvuer
            },
            props: {
                base64: {},// rename to pdf_bytes
                signature_svg: { //* object containing signature and initial
                    default: null,
                },
                sign_mode: {
                    default: false
                }
            },
            watch: {
                progress() {
                    if (this.progress > 100) {
                        this.$emit('progress', 100);
                    } else {
                        this.$emit('progress', this.progress);
                    }
                }
            },
            computed: {
                signModeText() {
                    if (this.sign_mode) {
                        return 'Disable Sign Mode'
                    } else {
                        return 'Enable Sign Mode'
                    }
                }
            },
            data: () => ({
                savedB64: null,
                //sign_mode: false,
                progress: 0,
                pdf_bytes: null,
                pdf: null,
                hasMounted: false,
                finishedLoading: false,
                loading_message: '',
                //* history of signatures
                signatures: [], //* {page_index,coords}
                is_redrawing: false,
                signed_pdf: null,

                pdf_as_unit8Array: null,
                viewB64: null,
                page: 1,
                numPages: 0,
                //scale: 'page-width',
                scale: 1,

                signature_mode: 'signature', // signature or initial
                //sign_mode: true,
                last_page_observer: null,
            }),
            template: `
                <div> 

                    <b-alert variant="dark" :show="finishedLoading == false">
                        <h3>{{loading_message}}</h3>
                    </b-alert>
                    <b-overlay :opacity=1 variant="light" :show="is_redrawing || finishedLoading == false">
                        <div v-if="sign_mode">
                            <div class="toolbar">
                                <div class="tool">
                                    <div class="d-flex">
                                        <button v-if="signatures" :disabled="signatures.length == 0" class="btn btn-danger btn-sm" @click="clearPage()">Clear Page</button>
                                        &nbsp;
                                        <button v-if="signatures" :disabled="signatures.length == 0" class="btn btn-warning btn-sm" @click="undoLastSignature()"><i class="fa fa-undo"></i> Undo</button>
                                        &nbsp;
                                        
                                        <span class="btn-group">
                                            <button :class="signature_mode == 'signature' ? 'btn-info' : 'btn-light' "
                                                class="btn btn-info btn-sm" @click="signature_mode = 'signature'">
                                                <i class="fas fa-signature me-1"/>
                                                Signature
                                            </button>
                                            <button :class="signature_mode == 'initial' ? 'btn-info' : 'btn-light' "
                                                class="btn btn-info btn-sm" @click="signature_mode = 'initial'">
                                                <i class="fas fa-marker me-1"/>
                                                Initial
                                            </button>
                                        </span>
                                        <button v-if="signatures" :disabled="signatures.length == 0" class="ms-auto btn btn-success btn-sm" @click="savePDF()">
                                            <i class="fas fa-save me-1"/>
                                            Save Signed Document
                                        </button>
                                    </div>
                                </div>
                            </div>
                                <div id="pdfScrollBar" class="pdfScrollBar" style="height: 50rem; overflow-y: scroll;">
                                <div id="pdf-container" style="width: 100%;" class="pdf-container"></div>
                            </div>
                        
                        </div>

                        <!-- //* normal viewer with zoom ability -->
                        <div v-if="sign_mode == false">
                            <div class="toolbar">
                                <div style="width: 100%; " class="tool">
                                    <span>
                                        <span class="btn-group">
                                            <button @click="zoomMinus()" class="btn btn-info btn-sm">
                                                <i class="fas fa-search-minus fa-lg"></i>
                                            </button>
                                            <button @click="zoomPlus()" class="btn btn-info btn-sm">
                                                <i class="fas fa-search-plus fa-lg"></i>
                                            </button>
                                            <button @click="scale = 1" v-show="scale != 1" class="w-xs btn btn-primary btn-sm">
                                                Reset Zoom
                                            </button>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <simplebar style="max-height: 90vh;">
                                <div class="pdf-vuer-pages" >
                                    <pdf :src="pdf_bytes" v-for="i in numPages" :key="i" :id="i" :page="i"
                                        :scale.sync="scale" style="width:100%;margin:20px auto;"
                                        :annotation="true"
                                        >
                                    <template slot="loading">
                                        loading content here...
                                    </template>
                                    </pdf>
                                </div>
                            </simplebar>
                        </div>
                    </b-overlay>
                </div>
            `,
            mounted() {
                window.annotate_inst = this;
                if (this.base64 == undefined) {
                    Swal.fire('PDF PLUGIN REQUIRES IS MISSING DATA')
                } else {
                    this.pdf_bytes = this.base64;
                    if (this.sign_mode) {
                        this.initJSPDF();
                    }
                    else {
                        this.pdf_as_unit8Array = new Uint8Array(this.pdf_bytes);
                        this.getPdf();
                        this.finishedLoading = true;
                    }

                }
            },
            destroyed() {
                window.annotate_inst = undefined;
            },
            methods: {
                ...sopClientMethods,
                zoomMinus() {
                    this.scale -= this.scale > 0.2 ? 0.1 : 0;
                },
                zoomPlus() {
                    this.scale += this.scale < 2 ? 0.1 : 0
                },
                toggleSignMode() {
                    this.$emit('toggleSignMode');
                },
                async insertSignature(page_index = 0, coords = { x: 0, y: 0 },) {
                    window.annotate_inst.is_redrawing = true;
                    this.savedB64 = null;
                    //* create internal pdf
                    window.annotate_inst.signed_pdf = await PDFDocument.load(this.pdf_bytes);

                    const pages = window.annotate_inst.signed_pdf.getPages();

                    // get the x/y for the clicked page
                    let x = (pages[page_index].getWidth() * coords.x * 100) / 100;
                    let y = (pages[page_index].getHeight() * coords.y * 100) / 100;

                    //* Y cooord starts from the bottom ;
                    y = pages[page_index].getHeight() - y;
                    //* Offset sothat svg is in center of mouse coords
                    //* Using 75 because svg width is 300 but scaled down  ---
                    let scale = (300 / 2) * 0.2

                    x = x - scale;
                    y = y + scale; // why

                    //* insert new signature into the histroy array and draw again
                    //alert(`Page IDX ${page_index}/${pages.length}`)

                    let points = null//svg_points;
                    points = this.signature_svg[this.signature_mode];
                    if (points != "" || points != null) {
                        points = JSON.parse(points);
                    }
                    let new_signature = {
                        x: x,
                        y: y,
                        page_index: page_index,
                        points: points
                    }

                    this.signatures.push(new_signature);

                    //* insert signatures 
                    await this.drawSignatures(pages);
                    this.processSignatures(this.signed_pdf);

                },
                async clearPage() {
                    window.annotate_inst.is_redrawing = true;
                    this.savedB64 = null;
                    //* create internal pdf
                    window.annotate_inst.signed_pdf = await PDFDocument.load(this.pdf_bytes);
                    const pages = window.annotate_inst.signed_pdf.getPages();
                    // clear all
                    this.signatures = [];
                    //* insert signatures 
                    await this.drawSignatures(pages);
                    this.processSignatures(this.signed_pdf);
                },
                async undoLastSignature() {
                    window.annotate_inst.is_redrawing = true;
                    this.savedB64 = null;
                    //* create internal pdf
                    window.annotate_inst.signed_pdf = await PDFDocument.load(this.pdf_bytes);
                    const pages = window.annotate_inst.signed_pdf.getPages();

                    //* remove last element
                    this.signatures.pop();
                    //* insert signatures 
                    await this.drawSignatures(pages);
                    this.processSignatures(this.signed_pdf);
                },
                async drawSignatures(pages) {
                    // Assuming 'this.signatures' is an array of signature objects
                    for (const signature of this.signatures) {
                        // Debugging: Log signature details (optional)
                        console.table({
                            page_index: signature.page_index,
                            x: signature.x,
                            y: signature.y,
                        });

                        // Draw each point in the signature on the specified page
                        for (const point of signature.points) {
                            // Draw the signature path on the canvas of the specific page
                            // Adjust properties as needed (e.g., scale, borderWidth)
                            await pages[signature.page_index].drawSvgPath(point, {
                                x: signature.x,
                                y: signature.y,
                                scale: 0.2,
                                borderWidth: 4,
                            });
                        }
                    }
                },
                async processSignatures(pdf) {
                    const pdfbytes = await pdf.save();
                    const blob = new Blob([pdfbytes], { type: 'application/pdf' });
                    let array_buffer = await new Response(blob).arrayBuffer();

                    let pdfScrollBar = $("#pdfScrollBar").first();
                    let scroll_pos = pdfScrollBar.scrollTop();
                    //* remove old pages
                    const parent_container = document.getElementById('pdf-container')
                    while (parent_container.firstChild) {
                        parent_container.removeChild(parent_container.firstChild);
                    }
                    this.initJSPDF(array_buffer, scroll_pos);
                },
                async savePDF() {
                    //const saved_b64 = await this.signed_pdf.saveAsBase64({ dataUri: true });
                    this.is_redrawing = true;
                    const pdfbytes = await this.signed_pdf.save();
                    const blob = new Blob([pdfbytes], { type: 'application/pdf' });
                    this.$emit('saveSignedPDF', blob);
                },
                getPdf() {
                    var self = this;
                    self.pdf_bytes = pdfvuer.createLoadingTask(self._arrayBufferToBase64(self.pdf_bytes));
                    self.pdf_bytes.then(pdf => {
                        self.numPages = pdf.numPages;
                        //eslint-disable-next-line
                        function changePage() {
                            var i = 1, count = Number(pdf.numPages);
                            do {
                                if (window.pageYOffset >= self.findPos(document.getElementById(i)) &&
                                    window.pageYOffset <= self.findPos(document.getElementById(i + 1))) {
                                    self.page = i
                                }
                                i++
                            } while (i < count)
                            if (window.pageYOffset >= self.findPos(document.getElementById(i))) {
                                self.page = i
                            }
                        }

                    });
                },
                async initJSPDF(data = null, scroll_pos = null) {
                    window.annotate_inst.loading_message = "Rendering PDF Document";
                    let pdfContainer = async function (container_id, pdf_bytes, options = {}) {
                        this.container_id = container_id;
                        this.pdf_bytes = data != null ? data : pdf_bytes;
                        this.scale = options.scale ? options.scale : 1.3;
                        this.number_of_pages = 0;
                        this.active_canvas = 0;
                        // Other properties...
                
                        var loadingTask = pdfjsLib.getDocument({ data: this.pdf_bytes });
                        
                        try {
                            let pdf = await loadingTask.promise;
                            this.number_of_pages = pdf.numPages;
                
                            // Pre-create canvas elements for each page
                            for (let i = 1; i <= this.number_of_pages; i++) {
                                const canvas = document.createElement('canvas');
                                canvas.id = `page-${i}-canvas`;
                                canvas.className = 'pdf-canvas';
                                document.getElementById(this.container_id).appendChild(canvas);

                                // Add event listener for sign mode
                                if (window.annotate_inst.sign_mode) {
                                    canvas.addEventListener('click', event => {
                                        const rect = canvas.getBoundingClientRect();
                                        const clickWidth = event.clientX - rect.left;
                                        const clickHeight = event.clientY - rect.top;
                                        let percentWidth = clickWidth / event.target.clientWidth;
                                        let percentHeight = clickHeight / event.target.clientHeight;

                                        let page_index = i - 1; // Use the loop index for page index
                                        let coords = { x: percentWidth, y: percentHeight };
                                        window.annotate_inst.insertSignature(page_index, coords, null);
                                    });
                                }
                            }
                
                            // Sequentially render each page
                            for (let i = 1; i <= this.number_of_pages; i++) {
                                const page = await pdf.getPage(i);
                                const viewport = page.getViewport({ scale: this.scale });
                                const canvas = document.getElementById(`page-${i}-canvas`);
                                canvas.width = viewport.width;
                                canvas.height = viewport.height;
                                const context = canvas.getContext('2d');
                                const renderContext = { canvasContext: context, viewport: viewport };
                                await page.render(renderContext).promise;
                            }
                
                            if (scroll_pos != null) {
                                document.getElementById(this.container_id).scrollTop = scroll_pos;
                            }
                            
                            let lastCanvasId = `page-${this.number_of_pages}-canvas`;
                            window.annotate_inst.last_page_observer = new IntersectionObserver(function(entries) {
                                if (entries[0].isIntersecting === true)
                                    window.annotate_inst.progress = 100;
                                },
                                { threshold: [0] }
                            );
                            // Observe the last page's canvas
                            window.annotate_inst.last_page_observer.observe(document.getElementById(lastCanvasId));
                            // Additional setup or callbacks...
                            options.ready?.();
                        } catch (reason) {
                            console.error(reason);
                        }
                    };
                
                    // Instantiate the pdfContainer
                    this.pdf = new pdfContainer('pdf-container', data || this.pdf_bytes, {
                        // Additional options...
                        ready() {
                            window.annotate_inst.finishedLoading = true;
                            window.annotate_inst.is_redrawing = false;
                        },
                        scale: 1.1,
                        // Other options...
                    });
                },                
                _arrayBufferToBase64(buffer) {
                    var binary = '';
                    var bytes = new Uint8Array(buffer);
                    var len = bytes.byteLength;
                    for (var i = 0; i < len; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    return ('data:application/pdf;base64,' + window.btoa(binary));
                }
            },
        })
    }
}